module.exports = __webpack_public_path__ + "static/media/builtinv2-IMG_3306.605c6cc8.png";